<template>
  <div class="auth">
    <box ref="box"></box>
    <el-card shadow="never" :style="style">
      <el-form :inline="true" ref="searchForm" class="search-form">
        <el-form-item>
          <span class="queryInfo">{{ $t('recentQuery') }} {{ updateTime }}</span>
        </el-form-item>
        <el-form-item style="float: right">
          <el-button style="width: 90px" type="primary" :loading="searching"
                     @click="_getGrant()">{{$t('queryButton')}}</el-button>
        </el-form-item>
      </el-form>
      <div class="content">
<!--        <div class="inlineContent">
          <span class="name">{{ $t('trialDays') }}</span>
          <span>{{ trialDays }}</span>
        </div>-->
        <div class="inlineContent">
          <span class="name">{{ $t('remainingDays') }}</span>
          <span>{{ remainDays }}</span>
        </div>
        <div class="inlineContent">
          <span class="name">{{ $t('setTimes') }}</span>
          <span>{{ remainSetTimes }}</span>
        </div>
        <div class="inlineContent">
          <span class="name">{{ $t('psn1') }}</span>
          <span>{{ psn }}</span>
        </div>
        <div class="inlineContent">
          <span class="name">{{ $t('serialNumber') }}</span>
          <span>{{ serialNo }}</span>
        </div>
        <div class="inlineContent">
          <span class="name">{{ $t('panelVersion') }}</span>
          <span>{{ version }}</span>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import Box from "@/components/Box";
import {getGrantCache, getGrant} from "@/api/query"
import Status from "components/Status";
import {formatDate} from "assets/utils";

export default {
  name: "authorizationManagement",
  mixins: [Status],
  components: {
    Box
  },
  data() {
    return {
      bottomHeight: null,
      style: null,
      remainSetTimes: '',
      trialDays: '',
      psn: '',
      updateTime: '',
      version: '',
      controllerNo: '',
      remainDays: '',
      serialNo: '',
      searching: false
    }
  },
  mounted() {
    this.calcHeight()
    // this._getGrantCache()
  },
  computed: {
    controllInfo() {
      return this.$store.state.controlInfo
    }
  },
  methods: {
    calcHeight() {
      setTimeout(() => {
        this.bottomHeight = this.$refs.box.$el.clientHeight + 'px'
        this.style = `height: calc(100vh - 100px - ${this.bottomHeight})`
      }, 20)
    },
    _getGrantCache() {
      getGrantCache({controllerPsn: this.controllInfo.controllerPsn}).then((res) => {
        this.trialDays = res.data.trialDays
        this.remainDays = res.data.remainDays
        this.remainSetTimes = res.data.remainSetTimes
        this.psn = res.data.psn
        this.serialNo = res.data.serialNo
        this.version = res.data.version
      })
    },
    _getGrant() {
      this.searching = true
      this.show()
      getGrant({controllerPsn: this.controllInfo.controllerPsn, controllerNo: this.controllInfo.controllerNo}).then((res) => {
        this.trialDays = res.data.trialDays
        this.remainDays = res.data.remainDays
        this.remainSetTimes = res.data.remainSetTimes
        this.psn = res.data.psn
        this.serialNo = res.data.serialNo
        this.version = res.data.version
        this.updateTime = formatDate(new Date())
        this.searching = false
        this.success(res.message ? res.message : '操作成功')
      }).catch(() => {
        this.failed()
        this.searching = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.auth {
  width: 100%;
  height: 100%;

  .search-form {
    border-bottom: 1px solid #EBEEF5;

    .queryInfo {
      padding: 0 10px;
      color: #B3BBC1;
      font-size: 12px;
    }
  }

  .content {
    padding-top: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: 14px;
    text-align: left;
    color: #212A3D;

    .inlineContent {
      vertical-align: middle;
      padding-left: 20px;

      .name {
        width: 120px;
        line-height: 30px;
      }

      > span {
        line-height: 30px;
        display: inline-block;
        white-space: nowrap;
        word-break: break-all;
        overflow: hidden;
      }
    }
  }
}
</style>
